module.exports = __webpack_public_path__ + "static/img/layer_back_active.68f623fc.png";